import { useEffect, useRef, useState } from "react";
import { api } from "../lib/api";

// Picks up scans pushed by scripts/reader_bridge.py (PC/SC helper) - no keyboard emulation needed.
// Polls fast only while the bridge is online; slows down otherwise and backs off while the server is unreachable.
export const useReaderBridge = (onScan, { enabled = true, intervalMs = 700, idleMs = 3000 } = {}) => {
  const [online, setOnline] = useState(false);
  const [lastPush, setLastPush] = useState(null);
  const seq = useRef(null);
  const cb = useRef(onScan);
  cb.current = onScan;

  useEffect(() => {
    if (!enabled) return undefined;
    let stop = false;
    let timer = null;
    let fails = 0;
    let bridgeOnline = false;
    const poll = async () => {
      try {
        const { data } = await api.get("/reader/pending", { params: { after: seq.current ?? 0 }, timeout: 6000 });
        if (stop) return;
        fails = 0;
        bridgeOnline = data.bridge_online;
        setOnline(data.bridge_online);
        if (seq.current === null || data.seq < seq.current) {
          seq.current = data.seq;
        } else {
          for (const s of data.scans) {
            seq.current = s.seq;
            setLastPush({ uid: s.uid, at: Date.now() });
            cb.current(s.uid);
          }
        }
      } catch {
        fails += 1;
      } finally {
        if (!stop) timer = setTimeout(poll, fails ? Math.min(10000, 2000 * fails) : bridgeOnline ? intervalMs : idleMs);
      }
    };
    poll();
    return () => { stop = true; clearTimeout(timer); };
  }, [enabled, intervalMs, idleMs]);

  return { online, lastPush };
};
